import React, { useEffect, useState } from "react";
import { Field, Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import MainLayout from "../../../components/layout/mainLayout/mainLayout";
import InputField from "../../../components/form/inputField/inputField";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import StateListTable from "../../../components/tables/stateListTable";
import {
  settingsStateCreate,
  settingsStateEdit,
  settingsStateList,
} from "../../../redux/actions/settingsActions";
import SuccessPopup from "../../../components/popups/SuccessPopup";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import searcher from "../../../assets/icons/searchInput.svg";

const SettingsState = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const search = queryParamsData.get("search") ?? "";
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [disable, setDisable] = useState(true);
  const [editEnable, setEditEnable] = useState(false);
  const [stateListData, setStateListData] = useState("");
  const [stateId, setStateId] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();
  const [loading, setLoading] = useState(false);
  const [catchedErrorPopup, setCatchedErrorPopup] = useState(false);
  const [catchedErrorMsg, setCatchedErrorMsg] = useState();
  const [userData, setUserData] = useState(null);

  const user_type = localStorage.getItem("userType");
  useEffect(() => {
    if (user_type === "super_admin") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Settings" && item
      );

      setUserData(permissionValue);
    }
  }, [user_type]);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    fetchStateList();
  }, [page, search]);

  const initialValues = {
    name: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().trim().required("Required"),
  });

  const onSubmit = (values, { resetForm }) => {
    if (!editEnable) {
      dispatch(settingsStateCreate(values, onSuccess, onError));
    } else {
      dispatch(
        settingsStateEdit(
          {
            state_id: stateId,
            name: values?.name,
          },
          onEditSuccess,
          onEditError
        )
      );
    }

    resetForm({
      values: {
        name: "",
      },
    });
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    fetchStateList();
  };

  const onSuccess = (data) => {
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowSuccessMsg(str_modify);
    setShowSuccessPopup(true);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const onEditSuccess = (data) => {
    fetchStateList();
    setEditEnable(false);
  };

  const onEditError = (err) => {
    console.log(err);
  };

  const fetchStateList = () => {
    setLoading(true);
    dispatch(
      settingsStateList({ page, search }, onGetStateSuccess, onGetStateError)
    );
  };

  const onGetStateSuccess = (data) => {
    console.log(data);
    setLoading(false);
    setStateListData(data?.data?.data);
  };

  const closeCatchedErrPopup = () => {
    setCatchedErrorPopup(false);
  };

  const onGetStateError = (err) => {
    console.log(err);
    setLoading(false);
    setCatchedErrorPopup(true);
    setCatchedErrorMsg(err.data.message);
  };

  const FormEnableCheck = () => {
    const {
      values: { name },
    } = useFormikContext();
    useEffect(() => {
      if (name.trim() != "") {
        setDisable(false);
      } else setDisable(true);
    }, [name]);
    return null;
  };

  const editSetForm = (item, index, setFieldValue) => {
    console.log(item?.name, "dsfghfdsghfewasfghgfdsasfhg");
    setEditEnable(true);
    setStateId(item?.id);
    setFieldValue("name", item.name);
  };
  return (
    <>
      <MainLayout breadCrumb="ADMIN  /  settings  /  State">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ errors, setFieldValue, values }) => (
            <Form>
              <FormEnableCheck />

              <>
                {(user_type == "super_admin" && userData?.write) ||
                user_type == "admin" ? (
                  <>
                    <div className="basic-details-container my-3 mt-4 mx-4 my-auto d-flex align-items-center ">
                      <label className="basic-title mx-2 mb-1">State</label>
                    </div>
                    <div className="form-width ms-4 ps-3 py-1">
                      <div className="my-2">
                        <InputField
                          id={"name"}
                          label={"State"}
                          labelColor={"color_262c3d"}
                          type={"text"}
                          placeholder={"Enter state name"}
                          name={"name"}
                          value={values.name}
                        />
                      </div>
                      <div
                        className="d-flex justify-content-end"
                        style={{ maxWidth: "450px" }}
                      >
                        {!editEnable ? (
                          <button
                            type="submit"
                            className="add-button fs_18 fw_700 fs_sm_12 px-4 py-2 w-50"
                            style={{ maxWidth: "210px" }}
                            disabled={disable}
                          >
                            Create
                          </button>
                        ) : (
                          <button
                            type="submit"
                            className="add-button fs_14 fw_700 fs_sm_12 px-4 py-2 w-50"
                            style={{ maxWidth: "210px" }}
                          >
                            Edit
                          </button>
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
                <div className="basic-details-container my-3 mt-4 mx-4 my-auto d-flex align-items-center ">
                  <label className="basic-title mx-2 mb-1">State List</label>
                </div>
                <div className="mt-4 inside-table-container mx-4">
                  <div className=" my-2 search-container ">
                    <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
                      <img className="styled-SVG" src={searcher} color={""} />
                      <input
                        value={search}
                        className="search-input fs_14 fw_400 px-2 text-dark"
                        type="text"
                        placeholder="Search state here by state name..."
                        onChange={(e) => {
                          navigate(
                            `/settings/state?page=1${
                              e.target.value ? `&search=${e.target.value}` : ""
                            }`
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div className="px-1 position-relative">
                    <StateListTable
                      stateListData={stateListData}
                      setFieldValue={setFieldValue}
                      editSetForm={editSetForm}
                      setPage={setPage}
                      page={page}
                      search={search}
                      loading={loading}
                    />
                  </div>
                </div>
              </>
            </Form>
          )}
        </Formik>
      </MainLayout>
      <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
      <ErrorPopup
        show={catchedErrorPopup}
        title={catchedErrorMsg}
        handleClose={closeCatchedErrPopup}
      />
    </>
  );
};

export default SettingsState;
